import { Extension } from '@tiptap/core';

// Custom Extension to handle '/' key
const SlashCommand = Extension.create({
  name: 'slashCommand',

  // Accept options during initialization
  addOptions() {
    return {
      handleOnSlashCommand: null, // Default to null
    };
  },
  addKeyboardShortcuts() {
    return {
      '/': ({ editor }) => {
        if (this.options.handleOnSlashCommand) {
          this.options.handleOnSlashCommand(editor);
        }

        // Manually insert the "/" character into the editor
        editor.commands.insertContent('/');

        return true;
      },
    };
  },
});

export default SlashCommand;
